export const EXTERNAL_SYNC_PROVIDERS = {
  SHAREPOINT: 'sharepoint',
};
